export async function drawCatchphrase(outside: HTMLCanvasElement, canvas: CanvasRenderingContext2D, phrase: string, font: string, x: number, y: number, indexOffsetX: number) {
    // Draw the phrase on top of the image
    const lines = phrase.split('\n');
    const lineHeight = 80;
    const lineCount = lines.length;
    const lineDistance = 2;
    const fontSize = 48;
    // const font = font

    const maxWidth = outside.width / 3 - 2 * mmPrintMargin - x * toPixel;
    const startX = indexOffsetX + mmPrintMargin + x * toPixel;
    const startY = (outside.height) / 2 + mmPrintMargin + y * toPixel;

    canvas.font = fontSize + 'pt ' + font;
    canvas.fillStyle = '#000';
    canvas.textAlign = 'center';
    canvas.textBaseline = 'middle';

    for (let i = 0; i < lineCount; i++) {
        const line = lines[i];
        if (!line) continue; // Skip empty lines

        const lineLength = canvas.measureText(line).width;

        let newFontSize = fontSize;
        if (lineLength > maxWidth) {
            newFontSize = fontSize * maxWidth / lineLength;
        }

        canvas.font = newFontSize + 'pt ' + font;
        canvas.fillText(line, startX + maxWidth/2, startY + (i * lineHeight) + (i * lineDistance) + lineHeight / 2, maxWidth);
    }
}
